import { SWReactIcons } from '@similarweb/icons';

import { translate } from '../../../../services/i18n';

import { StyledPersonaFit, StyledPersonaFitLabel } from './styles';

export const PersonaFit = ({ onHover }: { onHover?: () => void }) => (
  <StyledPersonaFit onMouseEnter={onHover}>
    <SWReactIcons iconName="lightning" />
    <StyledPersonaFitLabel data-automation="ContactPersonaFit">
      {translate('contact_card.persona_fit')}
    </StyledPersonaFitLabel>
  </StyledPersonaFit>
);
